import muster from '@dbk-legacy/muster';
import addCommonAssets from './assets-common-global';

export default () => addCommonAssets(muster());
